var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tick text-block",class:{'is-linked': _vm.item.group}},[_c('div',{staticClass:"tick-icon"}),_c('h3',{staticClass:"tick-text",domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }